module.exports = __webpack_public_path__ + "763e72f04db34ce77df4b717a82b1f25.pdf";